module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_kimono@3x-1acdc15562e531571c987f148e4c8e81.webp";